module.exports = __webpack_public_path__ + "img/CHAIN BUFFER.997ee3fd.jpg";